export const convertFileToUrl = (file: string, url: string) => {
    return `${url}/static/${file}`;
};

export const convertProductImagesToUploadFiles = (imgs: Array<GQL.IImage> | undefined, url: string) => {
    return (imgs || []).map(i => {
        return {
            name: i.file,
            status: 'done',
            uid: i.id,
            url: convertFileToUrl(i.file, url),
            priority: i.priority
        } as any;
    });
};



// WEBPACK FOOTER //
// ./src/helpers/convertProductImagesToUploadFiles.ts